import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	recommendationTypeInviterActivity: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	recommendationTypeTenantActivity: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	recommendationTypeUnknown: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	recommendationCardAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectTypeUnknown: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	recommendationTypeInviterActivity: {
		id: 'projects-directory-v3-recommendations.recommendations-list.recommendation-card.recommendation-type-inviter-activity',
		defaultMessage: 'Used by {inviterName}',
		description: 'Recommendation type inviter activity',
	},
	recommendationTypeTenantActivity: {
		id: 'projects-directory-v3-recommendations.recommendations-list.recommendation-card.recommendation-type-tenant-activity',
		defaultMessage: 'Popular in your organization',
		description: 'Recommendation type tenant activity',
	},
	recommendationTypeUnknown: {
		id: 'projects-directory-v3-recommendations.recommendations-list.recommendation-card.recommendation-type-unknown',
		defaultMessage: 'Unknown recommendation type',
		description: 'Recommendation type unknown',
	},
	recommendationCardAriaLabel: {
		id: 'projects-directory-v3-recommendations.recommendations-list.recommendation-card.recommendation-card-aria-label',
		defaultMessage:
			'Recommended project: {projectName}, a {projectType} project. Recommendation reason: {recommendationType}',
		description: 'Recommendation card aria label',
	},
	projectTypeUnknown: {
		id: 'projects-directory-v3-recommendations.recommendations-list.recommendation-card.project-type-unknown',
		defaultMessage: 'Unknown project type',
		description: 'Project type unknown',
	},
});
export default messages;
